export default __webpack_public_path__ + "static/media/JOCK-ITCH.ba9f5fd6.png";